import { cn as e } from "../../../shared/utils.js";
import { Button as t } from "../../../button/primitive/button.js";
import { useTranslation as n } from "../../../i18n/hooks.js";
import { Select as r } from "../../../select/index.js";
import { ChevronLeftIcon as i, ChevronRightIcon as a } from "@systemeio/icons";
import { useId as o } from "react";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
//#region src/table/pagination/primitive/pagination.tsx
var l = [
	10,
	25,
	50
], u = ({ className: t, ...n }) => /* @__PURE__ */ s("div", {
	className: e("flex items-center justify-end gap-4", t),
	...n
});
u.displayName = "Pagination.Root";
var d = ({ className: t, label: n, options: i = l, ...a }) => {
	let u = o(), d = a.id ?? u, f = i.map((e) => ({
		value: e,
		label: e
	}));
	return /* @__PURE__ */ c("div", {
		className: "inline-flex items-center gap-2",
		children: [n && /* @__PURE__ */ s("label", {
			className: "text-text-secondary text-base",
			htmlFor: d,
			children: n
		}), /* @__PURE__ */ s("div", { children: /* @__PURE__ */ c(r.Root, {
			...a,
			items: f,
			size: "sm",
			"aria-label": n,
			children: [/* @__PURE__ */ s(r.Input, {
				id: d,
				className: e("w-18", t)
			}), /* @__PURE__ */ s(r.Content, { children: /* @__PURE__ */ s(r.List, { children: f.map((e) => /* @__PURE__ */ s(r.Option, {
				value: e.value,
				children: e.label
			}, e.value)) }) })]
		}) })]
	});
};
d.displayName = "Pagination.Select";
var f = ({ direction: e, ...r }) => {
	let { t: o } = n(), c = o(e === "prev" ? "public_pages_purchase.table.pagination.previous_page" : "public_pages_purchase.table.pagination.next_page");
	return /* @__PURE__ */ s(t, {
		size: "icon-sm",
		variant: "ghost-gray",
		"aria-label": c,
		...r,
		children: s(e === "prev" ? i : a, {})
	});
};
f.displayName = "Pagination.Button";
var p;
(function(e) {
	e.Root = u, e.Select = d, e.Button = f;
})(p ||= {});
//#endregion
export { p as Pagination };
